import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=05a389ca&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=05a389ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a389ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a389ca')) {
      api.createRecord('05a389ca', component.options)
    } else {
      api.reload('05a389ca', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=05a389ca&scoped=true", function () {
      api.rerender('05a389ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/components/Category/edit.vue"
export default component.exports